import React, { useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  RadioGroup,
  FormControlLabel,
  Radio,
  Button,
  Typography,
} from "@mui/material";
import { useSelector } from "react-redux";
import { selectRoutes } from "../../../Redux/Reducers/routeSlice";

const RouteDialog = ({
  open,
  onClose,
  onSubmit,
  selectedRouterOption,
  setSelectedRouterOption,
}) => {
  const routes = useSelector(selectRoutes);

  // Ensure SS&C is selected by default when dialog opens and no selection yet
  useEffect(() => {
    if (!routes || routes.length === 0) return;
    if (selectedRouterOption) return;

    const defaultRoute =
      routes.find((r) => {
        const abb = r.abbreviation?.toLowerCase() || "";
        return abb.includes("ssc") || abb.includes("ss&c") ;
      }) || routes[0];

    if (defaultRoute?.routerId) {
      setSelectedRouterOption(defaultRoute.routerId);
    }
  }, [routes, selectedRouterOption, setSelectedRouterOption]);
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
       <DialogTitle>
        <Typography
          variant="h6"
          component="div"
          align="center"
          style={{ flexGrow: 1, fontSize: "20px" }}
        >
          Select Router
        </Typography>
      </DialogTitle>
      <DialogContent dividers>
         
        <RadioGroup
          value={selectedRouterOption}
          onChange={(e) => setSelectedRouterOption(e.target.value)}
        >
          {routes.map((router) => (
            <FormControlLabel
              key={router.routerId}
              value={router.routerId}
              control={<Radio />}
              label={(router?.abbreviation || "").toUpperCase()}
            />
          ))}
        </RadioGroup>
      </DialogContent>
      <DialogActions>
        <Button
        sx={{
          margin:"0px 10px 5px 0px",
          width: "100px",
        }}
          variant="contained"
          onClick={() => onSubmit(selectedRouterOption)}
        >
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RouteDialog;

